import { env } from "../env/runtime";

/**
 * Where the identity service's HTTP routes are mounted: its own origin when `VITE_AUTH_URL` names
 * one (production keeps it on another host), otherwise the page's own origin, which proxies it.
 * Every typed client for those routes starts here, so none of them works the base out for itself.
 */
export const AUTH_API_BASE = env.VITE_AUTH_URL
  ? `${env.VITE_AUTH_URL.replace(/\/$/, "")}/api/auth`
  : "/api/auth";
